module.exports = require("./tg.d.ts");